interface RelativeTimeProps {
  date: Date;
  /** Text shown before the relative time, e.g. "Last error". */
  prefix?: string;
  className?: string;
}

/**
 * "2 min ago" beats an absolute timestamp here: the question this page answers
 * is "is it broken right now?", and a reader should not have to do timezone
 * arithmetic to find out. The exact time stays available on hover and to
 * assistive tech via <time dateTime>, so nothing is actually lost.
 */
export function formatRelative(date: Date, now: number = Date.now()): string {
  const seconds = Math.max(0, Math.round((now - date.getTime()) / 1000));
  if (seconds < 60) return 'just now';

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;

  const days = Math.round(hours / 24);
  return `${days} day${days !== 1 ? 's' : ''} ago`;
}

export function RelativeTime({ date, prefix, className = '' }: RelativeTimeProps) {
  const absolute = date.toLocaleString();
  return (
    <time dateTime={date.toISOString()} title={absolute} className={className}>
      {prefix ? `${prefix} ` : ''}
      {formatRelative(date)}
    </time>
  );
}
